// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U2S3","footer":"styles_footer__3AxYM","passCodeTooltip":"styles_passCodeTooltip__1kaSP"};